// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableglosary {
    width: 100%;
    margin-bottom: 1rem;
    color: #28282d;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Faultanalysis/GlossaryPageFaultanalysis.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".tableglosary {\r\n    width: 100%;\r\n    margin-bottom: 1rem;\r\n    color: #28282d;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
